import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, Text } from '@mantine/core';
export function Logo() {
    return (_jsx(Group, { justify: "center", gap: "xs", wrap: "nowrap", style: { textDecoration: 'none' }, children: _jsxs(Text, { component: "span", fw: 600, style: {
                fontFamily: "'Fredoka', var(--mantine-font-family), sans-serif",
                whiteSpace: 'nowrap',
                letterSpacing: '0.5px',
                fontSize: '1.9rem',
                lineHeight: '1.1'
            }, children: [_jsx(Text, { component: "span", inherit: true, c: "blue.6", style: { display: 'inline' }, children: "Toddler" }), _jsx(Text, { component: "span", inherit: true, c: "orange.6", style: { display: 'inline' }, children: "Speak" })] }) }));
}
